import { PageTransition } from './PageTransition'

export function PageHeader({ title }: { title: string; subtitle?: string }) {
  return (
    <PageTransition>
      <div className="flex flex-col gap-1">
        <p className="text-lg text-foreground font-semibold">{title}</p>
      </div>
    </PageTransition>
  )
}
